import { sortBy } from 'lodash';
import { genericProducts } from '@shared/generic-products';
import { ElementCategoryID } from '@shared/models/element-categories.model';
import { IProduct } from '@shared/models/product.model';
import { findElementCategoryAndSelectionsByProductId } from './element-category.helpers';

// Material product categories — energy and labour are product categories too
// but are not material products and are excluded from the import picker.
const MATERIAL_PRODUCT_CATEGORY_IDS = new Set<ElementCategoryID>([
  ElementCategoryID.Concrete,
  ElementCategoryID.Wood,
  ElementCategoryID.Insulation,
  ElementCategoryID.Metal,
  ElementCategoryID.Gypsum,
  ElementCategoryID.Ceramics,
  ElementCategoryID.WindowsDoors,
  ElementCategoryID.OtherProduct,
]);

/**
 * Every product that can be selected through a material product category,
 * sorted by name. A product qualifies when
 * {@link findElementCategoryAndSelectionsByProductId} resolves it to a material
 * category — i.e. the category system can reproduce it as a proper element.
 * Products that only hit the OtherProduct fallback (no real match) are excluded.
 */
export const categorySelectableProducts: IProduct[] = sortBy(
  genericProducts.filter((product) => {
    const match = findElementCategoryAndSelectionsByProductId(product.id);
    return !!match && MATERIAL_PRODUCT_CATEGORY_IDS.has(match.category_id);
  }),
  'name',
);
